import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../services/auth.service";
import TopBar from "../components/TopBar";
import DiseaseForm from "../components/forms/DiseaseForm";

function UpdateDisease() {
  const navigate = useNavigate();
  const { calfId, id } = useParams();

  useEffect(() => {
    if (!AuthService.getCurrentUser()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div>
      <TopBar link={"/maladie/" + calfId + "/" + id}></TopBar>
      <div className="mx-3 rounded-lg bg-white px-3 dark:bg-slate-900">
        <div className="mb-3 flex flex-col">
          <span className="mt-2 text-2xl font-bold text-stone-700 dark:text-slate-100">
            Modifier une maladie
          </span>
          <p className="mb-3 text-sm text-stone-400 dark:text-slate-300">
            Vous pouvez modifier les informations de cette maladie ici.
          </p>
          <DiseaseForm
            calfID={calfId}
            diseaseId={id}
            onDone={() => navigate("/veaux/" + calfId + "?view=health")}
            onCancel={() => navigate("/maladie/" + calfId + "/" + id)}
          />
        </div>
      </div>
    </div>
  );
}

export default UpdateDisease;
